export default "__VITE_ASSET__BsJKLK6D__"